export default __webpack_public_path__ + "static/media/Sanjivani160.59da66ae.jpg";